import {
  makeStyles,
  createStyles,
  Theme,
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
  Fade,
} from "@material-ui/core";

export const Tooltip = ({ children, variant = "dark", ...props }: TooltipProps) => {
  const classes = useStyles();

  return (
    <MuiTooltip
      classes={
        variant === "light"
          ? { tooltip: classes.tooltipLight, arrow: classes.arrowLight }
          : { tooltip: classes.tooltip, arrow: classes.arrow }
      }
      TransitionComponent={Fade}
      arrow
      {...props}
    >
      {children}
    </MuiTooltip>
  );
};

export type TooltipProps = {
  variant?: "light" | "dark";
} & MuiTooltipProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      marginTop: theme.spacing(1),
      fontWeight: "normal",
      fontSize: theme.spacing(1.25),
      lineHeight: 1.25,
      color: "white",
      backgroundColor: "#35353d",
      boxShadow: "0 10px 12px 0 rgba(51, 91, 130, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)",
    },
    arrow: {
      color: "#35353d",
    },
    tooltipLight: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
    arrowLight: {
      color: theme.palette.common.white,
    },
  }),
);
